import React from 'react';

export interface ContextValue {
  /**
   *
   * is in DOM Layer area, useful to avoid toggling wrapped up state when moving mouse in the dom layer
   */

  isOverDomLayer: boolean;
  /**
   *
   * Node currently selected
   */
  selectedNodeId?: string;

  /**
   *
   * Node being dragged
   */
  hoveredNodeId?: string;

  /**
   *
   * callback on focusing a nodelayer item
   */
  handleFocus?: (event: React.FocusEvent) => void;

  /**
   *
   * callback on focusing a nodelayer item
   */
  handleSelect?: (event: React.MouseEvent) => void;
}
export const LayerContext = React.createContext<ContextValue>({
  isOverDomLayer: false,
});
